"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radius = void 0;
exports.radius = {
    button: 4,
    popper: 2,
    modal: 4,
    input: 2,
    paper: 4,
    tag: 12,
};
//# sourceMappingURL=radius.js.map